import axios from 'axios' // eslint-disable-line no-unused-vars
import store from '@/store'
import {
  Message
  // Loading
} from 'element-ui' // eslint-disable-line no-unused-vars
/* 设置baseURL */
// let baseURL = '/api';
// // process.env.NODE_ENV  用于判断当前运行环境，根据 npm run serve 或 npm run build
// if (process.env.NODE_ENV == 'production') {
//     baseURL = 'http://192.168.1.211:17779';  //生产
// } else {
//     // baseURL = 'http://192.168.10.90:8085/';  //开发 http://124.70.92.18:8085
//     baseURL = 'http://192.168.1.211:17779';  //开发
// }

// axios.defaults.baseURL = baseURL
// 1. 创建新的axios实例，
const requests = axios.create({
  // baseURL: baseURL,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 10 * 10000
})
// const loadingInstance = ''

// 2.请求拦截器
// let requestUrl = null
requests.interceptors.request.use(config => {
  // requestUrl = config.url;
  config.headers.common['access_token'] = ''
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.common['access_token'] = token
  }
  // let data = JSON.parse(JSON.stringify(config))
  // if (data.params) {
  //   console.log('get', data);
  //   for (const [key, value] of Object.entries(data.params)) {
  //     console.log('value', value);
  //     if (value === null || value === "" || value === undefined, value === '') { //筛选条件可根据实际情况自行调整
  //       Reflect.deleteProperty(data.params, key);
  //     }
  //   }
  // } else if (data.data) {
  //   console.log('post', data);
  //   for (const [key, value] of Object.entries(data.data)) {
  //     if (value === null || value === "" || value === undefined, value === '') { //筛选条件可根据实际情况自行调整
  //       Reflect.deleteProperty(data.data, key);
  //     }
  //   }
  // }
  // config = JSON.parse(JSON.stringify(data))
  // const { method, data } = config;
  // if (method.toLowerCase() == 'post' && typeof data == 'object') {
  //   config.data = qs.stringify(data)
  // }
  return config
}, (error) => {
  loadingInstance = Loading.service({
    text: '加载中，请稍等',
    background: 'rgba(255,255,255,0.75)'
  })
  return Promise.reject(error)
}
)

// 3.响应拦截器
requests.interceptors.response.use(response => {
  // loadingInstance.close()
  // Message.error(response.data.message)

  // 接收到响应数据并成功后的一些共有的处置，关闭loading等
  return response.data
}, error => {
  // loadingInstance.close()
  /** *** 接收到异常响应的处置开始 *****/
  if (error.response) {
    // 1.公共错误处置
    // 2.根据响应码具体处置
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break
      case 401:
        error.message = '登录过期，重新登录'
        store.dispatch('logout').then(() => {
          window.location.reload()
        })
        break
      case 402:
        error.message = '登录过期，重新登录'
        store.dispatch('logout').then(() => {
          window.location.reload()
        })
        break
      case 403:
        error.message = '拒绝访问'
        setTimeout(function () {
          // window.location.href = baseUrlFormal + '/passport/login'
        }, 1500)
        break
      case 404:
        error.message = '请求错误,未找到该资源'
        // window.location.href = '/NotFound'
        break
      case 405:
        error.message = '请求方法未允许'
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器端出错'
        break
      case 501:
        error.message = '网络未实现'
        break
      case 502:
        error.message = '网络错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网络超时'
        break
      case 505:
        error.message = 'http版本不支持该请求'
        break
      case 5000:
        break
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处置
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页')
    }
    error.message = '连接服务器失败'
  }

  Message.error(error.message)
  /** *** 处置结束 *****/
  // 如果不需要错误处置，以上的处置过程都可省略
  return Promise.resolve(error.response)
})
/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
requests.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}
/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
requests.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}
// 4.导入文件
export default ({
  url,
  method = 'GET',
  data,
  params,
  headers,
  responseType
}) => {
  return requests({
    url,
    method,
    data,
    params,
    headers,
    responseType
  })
}
